module.exports = __webpack_public_path__ + "static/media/5.56944330.mp3";